<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="920">
    <v-card>
         <v-toolbar dense dark color="secondary">BILLING<v-spacer/><v-icon @click="emitToParent('cancel')">mdi-close</v-icon> </v-toolbar>
        <v-card-text>
             <v-form
                ref="form"
                class="mt-4"
                v-model="valid"
                lazy-validation
              >
              <v-row dense>
                  <!-- <span style="width: 140px;">
                    <v-autocomplete
                    v-model="area_code"
                    label="Area code"
                    :items="AREACODES"
                    class="mr-2"
                    dense
                    outlined
                    ></v-autocomplete>
                  </span> -->
               <v-autocomplete
                  v-if="state=='new'"
                  v-model="billedTo"
                  label="Select Trade name"
                  @focus="parse=false, isPrint=false"
                  dense
                  :items="CUSTOMERS"
                  item-text="trade_name"
                  return-object
                  outlined
                  append-outer-icon="mdi-send"
                  @change="receivables=[]"
                  @click:append-outer="getReceivables()"
               />
              </v-row>
              <div id="PrintBilling">
                    <p class="text-center" v-if="isPrint"><strong>{{business_name()}}</strong>
                          <br />{{business_address()}}<br />
                              VAT Reg. TIN: {{tin()}}
                      </p>
                      <br />
                 <table class="va-table mt-4" style="width: 100%;">
                    <tr>
                        <td width="70%" style="padding-right: 20px;"  valign="top">
                            <p class=" mb-1">BILLED TO: {{billedTo.lastname}}, {{billedTo.firstname}} </p>
                            <p class="mb-1">TRADE NAME: {{billedTo.trade_name}}</p>
                            <p class="mb-1">PHONE NUMBER: {{billedTo.contact_number}}</p>
                            <p class="mb-1">EMAIL ADDRESS: {{billedTo.email}}</p>
                            <p class="mb-1">ADDRESS: {{billedTo.address}}</p>
                        </td>
                       <td valign="top">
                         <p v-if="state != 'new'" class="mb-1">A.R. NO.: {{item.ar_num}} </p>
                          <v-text-field
                          v-else
                            dense
                            outlined
                            label="Enter A.R No."
                            v-model="ar_num"

                          />
                          <p v-if="state != 'new'" class="mb-1">ISSUED DATE: {{$moment(item.issued_date).format("YYYY-MMM-DD")}} </p>
                          <p v-if="state != 'new'" class="mb-1">STATUS: <span :class="STATUS_TEXT(item.status)">{{item.status}}</span> </p>
                          <p v-if="state != 'new' && item.status == 'paid'" class="mb-1">PAYMENT POSTED: {{$moment(item.issued_date).format("YYYY-MMM-DD")}} </p>
                       </td>
                    </tr>
                 </table>
                    
                  
                      <table class="va-table mt-4" style="width: 100%;">
                          <tr>
                            <th class="text-left pa-2" style="background: #f0f0f0;">Invoice</th>
                              <th class="text-left pa-2" style="background: #f0f0f0;">Date</th>
                              <th class="text-right pa-2" style="background: #f0f0f0;">Amount</th>
                          </tr>
                          <tr v-for="(item, index) in receivables" :key="index">
                              <td class="text-left pa-2" style="border-bottom: 1px solid #eee;">
                                <v-icon left color="error" small @click="receivables.splice(index,1)"  v-if="state == 'new'">mdi-delete</v-icon>
                                {{item.invoice}}</td>
                              <td class="text-left pa-2" style="border-bottom: 1px solid #eee;">
                                <template v-if="state != 'new'">
                                  {{item.date | moment($date_format)}}
                                </template>
                                  <template v-else>
                                  {{item.delivered_date | moment($date_format)}}
                                </template>
                              </td>
                              <td class="text-right pa-2" style="border-bottom: 1px solid #eee;">{{$money(item.amount)}}</td>
                          </tr>
                          <tr>
                            <th class="text-left pa-2" style="background: #f0f0f0;"></th>
                              <th class="text-right pa-2" style="background: #f0f0f0;">TOTAL</th>
                              <th class="text-right pa-2" style="background: #f0f0f0;">{{$money(TOTAL)}}</th>
                          </tr>
                      </table>
                        <div class="sm-font" v-if="item.status == 'paid'">
                            <p  class="mb-0">PAYMENT METHOD: {{item.payment_method}} </p>
                            <p class="mb-1" v-if="item.payment_method == 'Cheque'">
                              Bank: {{item.check_details.bank}} <br />
                              Check No.: {{item.check_details.cheque_no}}
                              </p>
                        </div>
              </div>
                  <v-alert 
                  dense
                  text
                  type="info"
                  v-if="receivables.length ==0 && parse == true">
                        No receivables found as of {{$moment().format('DD of MMM YYYY')}}
                  </v-alert>
                
             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small  text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
               <v-btn small text @click="isPrint=true, print()"><v-icon v-if="state != ''" left>mdi-printer</v-icon> Print</v-btn>
            <v-btn  small color="success" v-if="TOTAL>0 && item.status != 'paid'"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
     <va-billing-payment :show="payform" @DialogEvent="payEvent"/>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    state: {
        type: String,
        default: "new"
    },
    item: {
      type: Object,
      default:()=>{}
    }
  },
  data: () => ({
      valid: true,
      isPrint: false,
      payform: false,
      ar_num:'',
      parse: false,
      confirm: false,
      textRules: [
        v => !!v || 'Field is required'
      ],
      billedTo:{lastname:''},
      receivables: [],
       billing:{},
       area_code:''
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ISSUE BILLING"
         else 
            return "Post Payment"
      },
      CUSTOMERS() {
       return  this.$store.state.customers
      },
      TOTAL(){
        var total = this.receivables.reduce((res,item)=>res+=this.$IsNum(item.amount), 0)
        return total
      },
      INVOICES(){
          var arr = this.receivables.reduce((res,item)=>
          {
            res.push({invoice: item.invoice, date:item.delivered_date, amount: item.amount })
            return res
          },[])
        return arr
      },
       AREACODES() {
        var codes = this.$store.state.settings.reduce((res,item)=>{
          if(item.alias == 'codes') {
              res = item.value
          }
          return res
        },'')
        return codes.split(',')
    },
  },
  watch: {
      show(v) {
        if(!v) {
          this.billing = {}
          this.billedTo = {lastname:''}
          this.receivables=[]
        } else {
           if(this.state != "new"){
            this.billedTo = this.item.customer
            this.receivables = this.item.invoices
          }
        }
      }

  },
  methods: {
      validate () {
         if(this.state != 'new') {
           this.payform = true
         }
        var param  = {}
          param.billed_to=this.billedTo.id
          param.amount=this.TOTAL.toString()
          param.status = 'issued'
          param.ar_num = this.ar_num
          param.invoices = this.INVOICES
          param.customer={
              lastname: this.billedTo.lastname,
              firstname:this.billedTo.firstname,
              trade_name: this.billedTo.trade_name,
              address: this.billedTo.address,
          }
         this.billing = param
         if(this.state == 'new') {
            this.IssueBilling()
         }  
      },
      payEvent(e){
        this.payform = false
        if(e != 'close'){
             this.billing = this.item
             this.billing.payment_method = e.method
             this.billing.check_details = e.check_details
            this.billing.status = "paid"
            console.log(this.billing)
            this.SaveBilling()
        }
      },
    emitToParent (action) {
       this.$emit('DialogEvent', {action: action})
    },
    SaveBilling() {
          this.$http.post("billing/update", this.billing).then(response => {
             this.GET_RESPONSE(response)
             this.$emit('DialogEvent', {action: ''})
          }).catch(e => {
           console.log(e.data)
         })
    },
    IssueBilling() {
          this.$http.post("billing/issue", this.billing).then(response => {
             this.GET_RESPONSE(response)
             this.$emit('DialogEvent', {action: ''})
          }).catch(e => {
           console.log(e.data)
         })
    },
    getReceivables() {
      this.parse = false
      this.$http.post("receivable/by_customer",  {id: this.billedTo.id}).then(response => {
              response.data.items != null?this.receivables = response.data.items:this.receivables=[]
           this.parse = true
          }).catch(e => {
           console.log(e.data)
         })
    },
    print () {
      setTimeout(()=>{
        this.$htmlToPaper('PrintBilling')
      }, 200)
      
    }
  }
}
</script>
